var Handlebars = require("/root/project/webapp/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.escapeExpression, alias3=container.lambda;

  return "<div class=\"url-copy\">\n    <form class=\"form-horizontal\" role=\"form\">\n        <div class=\"form-group\">\n            <label class=\"col-sm-3 control-label\">\n                "
    + alias2(__default(require("/root/project/webapp/src/common/ui/template/helper/i18n.js")).call(alias1,"data:edit.name",{"name":"i18n","hash":{},"data":data}))
    + "\n            </label>\n            <div class=\"col-sm-9\">\n                <input class=\"form-control\" onfocus=\"this.select();\" value="
    + alias2(alias3((depth0 != null ? depth0.name : depth0), depth0))
    + " readonly>\n            </div>\n        </div>\n        <div class=\"form-group\">\n            <label class=\"col-sm-3 control-label\">\n                "
    + alias2(__default(require("/root/project/webapp/src/common/ui/template/helper/i18n.js")).call(alias1,"data:edit.uri",{"name":"i18n","hash":{},"data":data}))
    + "\n            </label>\n            <div class=\"col-sm-9\">\n                <input class=\"form-control url-text\" onfocus=\"this.select();\" value="
    + alias2(alias3((depth0 != null ? depth0.url : depth0), depth0))
    + " readonly>\n            </div>\n        </div>\n    </form>\n</div>\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./data/ui/template/modal/url-copy.hbs
// module id = 695
// module chunks = 0